<h2 mat-dialog-title>{{ dialogTitle }}</h2>

<form [formGroup]="form">
  <mat-dialog-content>
    <div class="flex flex-col items-stretch">
      @if (isEditing) {
      @if (validationMessage$ | async; as validationMessage) {
      <div class="bg-orange-50 border border-orange-200 rounded-md p-3 mb-4">
        <p class="text-orange-800 text-sm">{{ validationMessage }}</p>
      </div>
      }
      }
      <ng-container *ngIf="lastAssessmentEvent$ | async as assessment">
        <p *ngIf="assessment.details.assessment">
          <a (click)="prefill(assessment)" [testId]="testIds.PROVIDE_DATA_FROM_ASSESSMENT">Provide data from last
            assessment.</a>
        </p>
      </ng-container>
      <mat-form-field class="w-full" [testId]="testIds.WORK_REQUIRED_INPUT">
        <mat-label>Work required</mat-label>
        <textarea matInput cdkTextareaAutosize [cdkAutosizeMinRows]="2" formControlName="work_required"></textarea>
      </mat-form-field>
      <mat-form-field class="w-full" [testId]="testIds.ESTIMATED_TOTAL_COST_INPUT">
        <mat-label>Estimated total cost</mat-label>
        <input matInput type="number" formControlName="estimated_total_cost" />
      </mat-form-field>
      <div class="flex flex-row items-center space-x-4">
        <mat-checkbox formControlName="send_email" [testId]="testIds.EMAIL_QUOTATION_CHECKBOX"></mat-checkbox>
        <p>Email quotation?</p>
      </div>
      <mat-form-field *ngIf="form.value.send_email === true" [testId]="testIds.QUOTATION_RECIPIENT_INPUT">
        <mat-label>Email address</mat-label>
        <input matInput type="email" formControlName="email_address" />
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-flat-button mat-dialog-close [testId]="testIds.CANCEL_EVENT_DIALOG_BUTTON">
      Cancel
    </button>
    <button mat-flat-button color="primary" (click)="saveQuotation()" [disabled]="form.invalid || isEditing"
      [testId]="testIds.ADD_QUOTATION_BUTTON">
      {{ saveButtonText }}
    </button>
  </mat-dialog-actions>
</form>